import { currentTimeMillis, Format_YYYYMMDD_HHmmss, formatTimestamp, Module } from '@nu-art/ts-common';
import { ApiDef_GladosInterface } from '@app/advisor-shared';
import { apiWithBody, apiWithQuery, ModuleFE_Thunderstorm } from '@nu-art/thunderstorm-frontend/index';
const baseGladosLogsFileName = 'glados-logs';
export class ModuleFE_GladosInterface_Class extends Module {
    vv1;
    constructor() {
        super();
        this.vv1 = {
            updateNavigatorKnowledgeBaseVersion: apiWithQuery(ApiDef_GladosInterface.vv1.updateNavigatorKnowledgeBaseVersion),
            getNLPFindings: apiWithBody(ApiDef_GladosInterface.vv1.getNLPFindings),
            getGladosLogs: apiWithQuery(ApiDef_GladosInterface.vv1.getGladosLogs, this.downloadGladosLogs)
        };
    }
    downloadGladosLogs = async (response) => {
        ModuleFE_Thunderstorm.downloadFile({
            content: response.logs,
            fileName: `${baseGladosLogsFileName}-${formatTimestamp(Format_YYYYMMDD_HHmmss, currentTimeMillis())}.txt`
        });
    };
    init() {
    }
}
export const ModuleFE_GladosInterface = new ModuleFE_GladosInterface_Class();
//# sourceMappingURL=ModuleFE_GladosInterface.js.map